import React, { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

import { TextInput } from 'src/common/form/text-input';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { ShareLinkFieldType } from '../link-config-form.factory';

interface Props {
  password: ShareLinkFieldType<string>;
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
}

export const SharePasswordProtect = ({ password, onFieldChange }: Props) => {
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(!!password.value);

  const onPasswordToggleChanged = () => {
    setIsPasswordEnabled(!isPasswordEnabled);
  };

  useEffect(() => {
    if (!isPasswordEnabled && password.value !== '') {
      onFieldChange({ field: password.field, value: '' });
    }
  }, [isPasswordEnabled, onFieldChange, password.field, password.value]);

  return (
    <div className='flex flex-col space-y-4 text-bedrock-black py-6'>
      <ToggleComponent
        checked={isPasswordEnabled}
        onChange={onPasswordToggleChanged}
        label='Password protect'
        labelType='strong'
      />
      {isPasswordEnabled && (
        <TextInput
          onChange={(event: any) => {
            onFieldChange({ field: password.field, value: event.target.value.trim()});
          }}
          id='password'
          inputProps={{
            defaultValue: password.value,
            placeholder: 'Enter password',
          }}
        />
      )}
    </div>
  );
};
